<script setup lang="ts">
import StatBlock from "@/components/modules/Analytics/Charts/StatBlock.vue";
import DynamicByMonth from "@/components/modules/Analytics/Charts/DynamicByMonth.vue";
import RegionTop from "@/components/modules/Analytics/Charts/RegionTop.vue";
import {AccusedPersonsAnalyticProps} from "@/types/analytics";

defineProps<AccusedPersonsAnalyticProps>();
</script>

<template>
  <div class="params">
    <div class="params__wrapper">
      <StatBlock
        title="число обвиняемых по направленным в суд делам"
        :value="analyticData.totalData?.accused_in_court_cases?.value"
        :percent="analyticData.totalData?.accused_in_court_cases?.percent_to_previous"
        :is-appg="false"
        :is-main="true"
      />
      <StatBlock
        title="число н/л обвиняемых по делам (ч.1 ст. 427 УПК РФ)"
        :value="analyticData.totalData?.juvenile_accused?.value"
        :percent="analyticData.totalData?.juvenile_accused?.percent_to_previous"
        :is-appg="false"
      />
      <StatBlock
        title="число лиц по уголовным делам с ходатайством о назначении судебного штрафа (ст.446.2 УПК РФ)"
        :value="analyticData.totalData?.persons_with_court_fine?.value"
        :percent="analyticData.totalData?.persons_with_court_fine?.percent_to_previous"
        :is-appg="false"
      />
      <StatBlock
        title="число лиц, в отношении которых прекращены дела"
        :value="analyticData.totalData?.persons_with_terminated_cases?.value"
        :percent="analyticData.totalData?.persons_with_terminated_cases?.percent_to_previous"
        :is-appg="false"
      />
    </div>

    <DynamicByMonth
      :active-type="activeType"
      :selected-region="selectedRegion"
      :selected-district="selectedDistrict"
      :dynamic="analyticData.monthlyDynamic"
    />
    <template v-if="activeType !== 'region'">
      <RegionTop
        sort-order="desc"
        :active-type="activeType"
        :selected-district="selectedDistrict"
        :region-list="analyticData.topDescending"
      />
      <RegionTop
        sort-order="asc"
        :active-type="activeType"
        :selected-district="selectedDistrict"
        :region-list="analyticData.topAscending"
      />
    </template>
  </div>
</template>

<style scoped lang="scss">
.params {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;

  &__wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
    margin-top: auto;
  }
}
</style>